import { createClient } from "./utils";
import { ARBITRUM, BSC, AVALANCHE_FUJI, ETH_MAINNET } from "config/chains";

export const chainlinkClient = createClient(ETH_MAINNET, "chainLink");

export const arbitrumGraphClient = createClient(ARBITRUM, "stats");
export const arbitrumReferralsGraphClient = createClient(ARBITRUM, "referrals");
export const nissohGraphClient = createClient(ARBITRUM, "nissohVault");
export const arbitrumTradesGraphClient = createClient(ARBITRUM, "trades");

export const bscGraphClient = createClient(BSC, "stats");
export const bscReferralsGraphClient = createClient(BSC, "referrals");
export const avalancheFujiReferralsGraphClient = createClient(AVALANCHE_FUJI, "referrals");
export const bscTradesGraphClient = createClient(BSC, "trades");

export const arbitrumSyntheticsStatsClient = createClient(ARBITRUM, "syntheticsStats");
export const bscSyntheticsStatsClient = createClient(BSC, "syntheticsStats");
export const avalancheFujiSyntheticsStatsClient = createClient(AVALANCHE_FUJI, "syntheticsStats");

export const arbitrumSubsquidClient = createClient(ARBITRUM, "subsquid");
export const bscSubsquidClient = createClient(BSC, "subsquid");
export const avalancheFujiSubsquidClient = createClient(AVALANCHE_FUJI, "subsquid");

export function getSyntheticsGraphClient(chainId: number) {
  if (chainId === ARBITRUM) {
    return arbitrumSyntheticsStatsClient;
  }

  if (chainId === BSC) {
    return bscSyntheticsStatsClient;
  }

  if (chainId === AVALANCHE_FUJI) {
    return avalancheFujiSyntheticsStatsClient;
  }

  return null;
}

export function getSubsquidGraphClient(chainId: number) {
  if (chainId === ARBITRUM) {
    return arbitrumSubsquidClient;
  }

  if (chainId === BSC) {
    return bscSubsquidClient;
  }

  if (chainId === AVALANCHE_FUJI) {
    return avalancheFujiSubsquidClient;
  }

  return null;
}

export function getMoneyGraphClient(chainId: number) {
  if (chainId === ARBITRUM) {
    return arbitrumGraphClient;
  } else if (chainId === BSC) {
    return bscGraphClient;
  } else if (chainId === AVALANCHE_FUJI) {
    return null;
  }

  throw new Error(`Unsupported chain ${chainId}`);
}

export function getReferralsGraphClient(chainId) {
  if (chainId === ARBITRUM) {
    return arbitrumReferralsGraphClient;
  } else if (chainId === BSC) {
    return bscReferralsGraphClient;
  } else if (chainId === AVALANCHE_FUJI) {
    return avalancheFujiReferralsGraphClient;
  }
  throw new Error(`Unsupported chain ${chainId}`);
}

export function getTradesGraphClient(chainId) {
  if (chainId === ARBITRUM) {
    return arbitrumTradesGraphClient;
  } else if (chainId === BSC) {
    return bscTradesGraphClient;
  }
  throw new Error(`Unsupported chain ${chainId}`);
}
